module.exports = __webpack_public_path__ + "static/img/total_zh.9945ac2b.png";